<template>
  <div>
    <container>
      <div slot="left_box_content">
        <component :is="curLeftComponent"></component>
      </div>
      <div slot="right_box_content">
        <component :is="curRightComponent"></component>
      </div>
      <div slot="bottom_box_content">
        <div class="platform-buttom-list">
          <div v-for="tag in tagList" :key="tag.key" @click="handleChangeTag(tag.key)"
           :class="tagType===tag.key? 'bottom-button-active':'bottom-button'">
           {{tag.value}}
          </div>
        </div>

        <component v-show="curBottomComponent === 'bottom_OrderList'" :is="'bottom_OrderList'"></component>
        <component v-show="curBottomComponent !== 'bottom_OrderList'" :is="curBottomComponent"></component>
      </div>
      <div slot="bg_map">
        <component :is="curMapComponent"></component>
      </div>

    </container>
  </div>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
// 引入store模块
import adxStoreModule from '@/store/modules/adx'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    centerComponent: () => import('./center/Edit'),
    // 左侧组件
    left_OrderCreate: () => import('./left/Create'),
    left_OrderEdit: () => import('./left/Edit'),
    // 底部组件
    bottom_OrderList: () => import('./bottom/List'),
    bottom_OrderEdit: () => import('./bottom/Edit'),
    bottom_OrderDetail: () => import('./bottom/Detail'),
    // 右侧组件
    right_OrderEdit: () => import('./right/Edit'),
    right_OrderDetail: () => import('./right/Detail')
  },
  data () {
    return ({
      tagType: 0,
      tagList: []
    })
  },
  created () {
    // 注册动态store模块
    if (!this.$store.hasModule('adx')) {
      this.$store.registerModule('adx', adxStoreModule)
    }
  },
  mounted () {
    this.setBottomComponent('bottom_OrderList')
    this.setBottomHeight('90%')
    this.setShowLeftBlock(false)
    this.setShowRightBlock(false)
    this.tagList = [
      { key: 1, value: '我的采购清单' }
    ]
    this.tagType = 1
  },
  methods: {
    clearPage () {
      // 清空地图标注
      this.$store.commit('set_adx_stations', [])
      this.$store.commit('set_adx_update_map', new Date())
      this.$store.commit('set_adx_show_assets', [])
      this.$store.commit('set_adx_defaultProduct', undefined)
    },
    handleChangeTag (val) {
      if (val === 1) {
        this.tagType = 1
        this.$store.commit('set_adx_pageType', 'list')
        this.setBottomComponent('bottom_OrderList')
        this.setBottomHeight('300px')
      } else {
        this.$store.commit('set_adx_pageType', val === 2 ? 'edit' : 'detail')
      }
    },
    loadPageComponent (type) {
      if (type === 'edit') {
        this.setShowRightBlock(true)
        this.setRightComponent('right_OrderEdit')
        this.setShowLeftBlock(true)
        this.setLeftComponent('left_OrderEdit')
        this.setBottomHeight('300px')
        this.setBottomComponent('bottom_OrderEdit')
        this.setMapComponent('centerComponent')

        this.tagList = [
          { key: 1, value: '我的采购清单' },
          { key: 2, value: '编辑订单' }
        ]
        this.tagType = 2
      } else if (type === 'detail') {
        this.setShowRightBlock(true)
        this.setRightComponent('right_OrderDetail')
        this.setShowLeftBlock(false)
        this.setLeftComponent('')
        this.setBottomHeight('90%')
        this.setBottomComponent('bottom_OrderDetail')
        this.setMapComponent('centerComponent')

        this.tagList = [
          { key: 1, value: '我的采购清单' },
          { key: 3, value: '订单详情' }
        ]
        this.tagType = 3
      } else if (type === 'create') {
        this.setShowLeftBlock(true)
        this.setLeftComponent('left_OrderCreate')
        this.setBottomHeight('90%')
        this.setShowRightBlock(false)
        this.setRightComponent('')
        this.setMapComponent('')
        this.tagList = [
          { key: 1, value: '我的采购清单' }
        ]
        this.tagType = 1
      }
    }
  },
  computed: {
    pageType () {
      return this.$store.state.adx ? this.$store.state.adx.pageType : ''
    },
    orderId () {
      return this.$store.state.adx ? this.$store.state.adx.orderId : ''
    }
  },
  watch: {
    pageType (val) {
      if (val !== 'list') {
        this.loadPageComponent(val)
      }
    },
    orderId (val) {
      this.clearPage()
    }
  },
  destroyed () {
    this.$store.commit('set_adx_pageType', '')
    // 卸载动态store模块
    this.$store.unregisterModule('adx')
    this.setShowLeftBlock(true)
    this.setShowMap(true)
    this.setShowRightBlock(true)
    this.setBottomHeight('300px')
    this.setLeftComponent('')
    this.setRightComponent('')
    this.setBottomComponent('')
    this.setMapComponent('')
    this.setLinkTagArray()
    this.setLinkRouterMaps()
    this.setActivedTagName('')
  }
}
</script>
